import { format } from 'date-fns'
import { typeOf } from './index'
import html2canvas from 'html2canvas'
import moment from 'moment'
import Files_Unknow from '@Assets/images/fileType/Files_Unknow.svg'
import Files_Pdf from '@Assets/images/fileType/Files_Pdf.svg'
import Files_Excel from '@Assets/images/fileType/Files_Excel.svg'
import Files_Word from '@Assets/images/fileType/Files_Word.svg'
import Files_Ppt from '@Assets/images/fileType/Files_Ppt.svg'
import Files_Txt from '@Assets/images/fileType/Files_Txt.svg'
import { PDFDocument } from 'pdf-lib'

export function wanUnitFormat(value, opts = {}) {
  const { decimals = 0, unitAfter = '' } = opts

  if (typeOf(value) === 'undefined' || typeOf(value) === 'null' || +value <= -1) return '--'

  const param = {}
  let k = 10000
  const units = ['', '万', '亿', '万亿']
  let step

  if (value < k) {
    param.value = value
    param.unit = ''
  } else {
    step = Math.floor(Math.log(value) / Math.log(k))

    // 超出units后取最大的unit
    step = Math.min(units.length - 1, step)

    param.value = (value / Math.pow(k, step)).toFixed(decimals)
    param.unit = units[step]
  }

  return param.value + param.unit + unitAfter
}

export function toWanHandle(value, currency = '', decimals = 1, unit = '万') {
  if (typeOf(value) === 'undefined' || typeOf(value) === 'null' || +value <= -1) return '--'
  return isNaN(+value) ? value : value > 1000 ? currency + (value / 10000).toFixed(decimals) + unit : currency + value
}

/**
 * @description
 * @param value
 * @param currency
 * @param decimals
 * @param emptyTag
 * @returns {*}
 */

export function currencyHandle(value, currency = '', decimals = 0, emptyTag = '-') {
  if (!isFinite(value) || (!value && value !== 0)) {
    return emptyTag
  }
  value = parseFloat(value)
  //
  const stringified = String(value)
  const idx = stringified.indexOf('.')
  let _int = ''
  let _float = ''
  let _floatStr = ''
  //
  if (idx !== -1) {
    _int = stringified.substring(0, idx)
    _floatStr = stringified.substring(idx)
  } else {
    _int = stringified
    _floatStr = '.'
  }
  if (decimals) {
    const _floatLen = decimals + 1
    // while (_floatStr.length < _floatLen) {
    //   _floatStr += '0'
    // }
    if (_floatStr.length < _floatLen) {
      _floatStr = _floatStr.padEnd(_floatLen, '0')
    }
    _float = _floatStr.substring(0, _floatLen)
  }
  //
  const i = _int.length % 3
  const head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : ''
  return (currency ? ' ' + currency : '') + head + _int.slice(i).replace(/(\d{3})(?=\d)/g, '$1,') + _float
}

export function fileType(name) {
  if (typeOf(name) !== 'string') return null

  const segment = name.split('.')

  return segment[segment.length - 1].toLocaleLowerCase()
}

export function IsImgType(name) {
  if (typeOf(name) === 'string') {
    const segment = name.split('.')
    const end = segment[segment.length - 1].toLocaleLowerCase()
    if (['jpg', 'png', 'jpeg'].includes(end)) {
      return true
    }
  }
  return false
}

export function findFileImage(name) {
  const ext = fileType(name)
  let image = Files_Unknow
  switch (ext) {
    case 'pdf':
      image = Files_Pdf
      break
    case 'xls':
    case 'xlsx':
    case 'csv':
      image = Files_Excel
      break
    case 'doc':
    case 'docx':
      image = Files_Word
      break
    case 'ppt':
      image = Files_Ppt
      break
    case 'txt':
      image = Files_Txt
  }

  return image
}

export function formatDate(date, formator = 'yyyy-LL-dd HH:mm:ss', sign = '--') {
  if (typeOf(date) === 'string') {
    return date
  }

  return date ? format(date, formator) : sign
}

export function toRate(value, base = 100, decimals = 1, unit = '%') {
  if (typeOf(value) === 'undefined' || typeOf(value) === 'null' || +value <= -1) return '--'

  return isNaN(+value) ? value : (value * base).toFixed(decimals) + unit
}

/**
 * @description
 * @param second
 * @param option
 * @returns {string}
 */
export function formatSecondStr(second, option = {}) {
  let d = 0
  let h = 0
  let m = 0
  let result = ''

  const options = {
    year: true,
    day: true,
    hour: true,
    minute: true,
    second: true
  }
  const padLeft = function (n = '') {
    return n > 9 ? n : '0' + n
  }
  //
  for (const prop in option) {
    options[prop] = option[prop]
  }

  if (second > 86400) {
    d = Math.floor(second / 86400)
    second = second % 86400
  }
  if (second > 3600) {
    h = Math.floor(second / 3600)
    second = second % 3600
  }
  if (second > 60) {
    m = Math.floor(second / 60)
    second = second % 60
  }
  if (options.second) {
    result = padLeft(second)
  }
  if (options.minute) {
    if (m >= 0 || h >= 0 || d >= 0) {
      result = m + ':' + result
    }
  }
  if (options.hour) {
    if (h > 0 || d > 0) {
      result = h + ':' + result
    }
  }
  if (options.day && d > 0) {
    result = d + ' ' + result
  }
  return result
}

export function secondFormat(second, format = 'm分s秒') {
  return moment.utc(second * 1000).format(format)
}

export function saveImage(id, fileName = 'statistic.jpg') {
  return new Promise((resolve, reject) => {
    const canvas2 = document.createElement('canvas')
    // let _canvas = document.getElementById('child');
    const _canvas = document.getElementById(id)
    const w = parseInt(window.getComputedStyle(_canvas).width)
    const h = parseInt(window.getComputedStyle(_canvas).height)
    // 将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
    canvas2.width = w * 2
    canvas2.height = h * 2
    // 貌似没用
    canvas2.style.width = w + 'px'
    canvas2.style.height = h + 'px'
    // 可以按照自己的需求，对context的参数修改,translate指的是偏移量
    // const context = canvas2.getContext('2d')
    // context.scale(2, 2)
    html2canvas(document.getElementById(id), {
      canvas: canvas2,
      allowTaint: true,
      useCORS: true,
      scale: 2,
      backgroundColor: '#f5f5f5'
    }).then(canvas => {
      const imgData = canvas.toDataURL('jpeg')
      saveFile(imgData, fileName).then(resolve)
    })
  })
}

export function savePdfImage(id, fileName = 'statistic.pdf') {
  return new Promise((resolve, reject) => {
    const canvas2 = document.createElement('canvas')
    // let _canvas = document.getElementById('child');
    const _canvas = document.getElementById(id)
    const w = parseInt(window.getComputedStyle(_canvas).width)
    const h = parseInt(window.getComputedStyle(_canvas).height)
    // 将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
    canvas2.width = w * 2
    canvas2.height = h * 2
    // 貌似没用
    canvas2.style.width = w + 'px'
    canvas2.style.height = h + 'px'
    // 可以按照自己的需求，对context的参数修改,translate指的是偏移量
    // const context = canvas2.getContext('2d')
    // context.scale(2, 2)
    html2canvas(document.getElementById(id), {
      canvas: canvas2,
      allowTaint: true,
      useCORS: true,
      scale: 2,
      backgroundColor: '#f5f5f5'
    }).then(async canvas => {
      const imgData = canvas.toDataURL('image/jpeg', 1)

      const doc = await PDFDocument.create()
      const image = await doc.embedJpg(imgData)
      const imagePage = doc.addPage([w, h])
      imagePage.drawImage(image, {
        x: 0,
        y: 0,
        width: w, // 设置图片的宽度和高度
        height: h,
        opacity: 1
      })

      // 保存 PDF 文档
      const pdfBytes = await doc.save()
      savePDF(pdfBytes, fileName).then(resolve)
    })
  })
}

export function savePDF(pdfBytes, fileName = 'statistic.pdf') {
  return new Promise(resolve => {
    // 生成 PDF 字节数组 pdfBytes

    // 创建一个 Blob 对象
    const blob = new Blob([pdfBytes], { type: 'application/pdf' })

    // 生成下载链接
    const downloadLink = URL.createObjectURL(blob)

    // 创建一个 <a> 元素并设置属性
    const a = document.createElement('a')
    a.href = downloadLink
    a.download = fileName // 设置下载文件的名称

    // 模拟点击 <a> 元素来触发下载
    a.click()

    // 清除临时下载链接
    URL.revokeObjectURL(downloadLink)
    resolve()
  })
}
export function saveFile(data, filename) {
  return new Promise((resolve, reject) => {
    const dom = document.createElement('a')
    dom.href = data
    dom.download = filename
    document.body.appendChild(dom)

    dom.click()
    document.body.removeChild(dom)
    resolve()
  })
}

export async function downloadBlobFile(options) {
  const { url, fileName } = options
  let isUseBlob = false
  let useUrl = url

  try {
    const response = await fetch(url)
    const blob = await response.blob()
    useUrl = window.URL.createObjectURL(blob)

    isUseBlob = true
  } catch (error) {
    cosnole.error(error)
  }

  const a = document.createElement('a')
  a.href = useUrl
  a.download = fileName
  document.body.appendChild(a)

  a.click()
  a.remove()

  if (isUseBlob) window.URL.revokeObjectURL(a.href)
}

export function formatVt(value, options = {}) {
  const { unit = '', placeholder = '--' } = options
  if (!isFinite(value) || (!value && value !== 0)) {
    return placeholder
  }

  return `${toWanHandle(value)}${unit}`
}
